export const REDRAW_NOTES_MAX_LENGTH = 500;
